import getAuditlogsActions from "./action";

const initialState = {
  Auditlogs: null,
};

const AuditlogsReducer = (state = initialState, action) => {
    switch (action.type) {
       case getAuditlogsActions.SET_AUDITLOGS:
             return {
               ...state,
               Auditlogs: action.payload,
             };

        default:
            return state;
    }
};

export default AuditlogsReducer;

